export const AB_GROUP = {
  masteryLevel: 18,
  aiComment: 20,
};
export const LS_MASTERY_POPUP_KEY = 'GB_MASTERY_POPUP';
